import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { checkSeriesDataXDateGreaterThanMin } from "./utils/checkSeriesDataXDateGreaterThanMin";
import { convertToNumber } from "./utils/convertToNumber";

const DEFAULT_X_MIN = "2000";

export function trendDateLocks(states: Partial<EvaChartStates>) {
  const { locks, series } = states;

  const lockedXMax =
    locks?.xMax?.type === DataEnum.Reset ? undefined : locks?.xMax?.value;
  // A default min past the user's max would flip the axis
  const isXMaxBeforeDefault =
    !!lockedXMax && new Date(String(lockedXMax)) <= new Date(DEFAULT_X_MIN);

  // A saved DefaultDate is recomputed from the data so a stale 2000 is never pinned
  const isUserXMinLock =
    locks?.xMin?.type !== DataEnum.DefaultDate && !!locks?.xMin?.value;

  const lockedXMin =
    locks?.xMin?.type === DataEnum.Reset
      ? undefined
      : isUserXMinLock
      ? locks?.xMin?.value
      : isXMaxBeforeDefault
      ? undefined
      : checkSeriesDataXDateGreaterThanMin(DEFAULT_X_MIN, series);

  // With no max lock ECharts takes max from the data, so a min past all data flips the axis
  // and pins the points to its edge; give it a forward range so they clip instead
  const minDate = lockedXMin ? new Date(String(lockedXMin)) : undefined;
  const isAllDataBeforeXMin =
    !!minDate &&
    !!series?.length &&
    series.every((s) =>
      s?.x?.every((value) => {
        const date = new Date(value);
        return isNaN(date.getTime()) || date < minDate;
      })
    );
  const defaultXMax =
    !lockedXMax && isAllDataBeforeXMin ? String(minDate.getUTCFullYear() + 1) : undefined;
  const xMax = lockedXMax ?? defaultXMax;

  const lockedYMin =
    locks?.yMin?.type === DataEnum.Reset ? undefined : locks?.yMin?.value;

  const lockedYMax =
    locks?.yMax?.type === DataEnum.Reset ? undefined : locks?.yMax?.value;

  // Tags the 2000 default so the locker doesn't persist it as a user lock
  const lockedXMinType = lockedXMin && !isUserXMinLock ? DataEnum.DefaultDate : undefined;

  return {
    lockedXMin: lockedXMin?.toString(),
    lockedXMax: xMax?.toString(),
    lockedYMin: convertToNumber(lockedYMin),
    lockedYMax: convertToNumber(lockedYMax),
    lockedXMinType,
    lockedXMaxType: defaultXMax ? DataEnum.DefaultDate : undefined
  };
}
